import { Logout } from '@gc-bridge/pages';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router';
import { RouterProvider } from 'react-router/dom';

const router = createBrowserRouter(
  createRoutesFromElements(<Route path="/logout" element={<Logout />} />)
);

export function PublicRouter() {
  return <RouterProvider router={router} />;
}

// TODO: Remove the code below after migration all remotes to use react-router
// eslint-disable-next-line import/first
import { RouterProvider as RP } from 'react-router-dom';
// eslint-disable-next-line import/first
import {
  createBrowserRouter as cbr,
  createRoutesFromElements as crfe,
  Route as R,
} from 'react-router-dom';

const r = cbr(crfe(<R path="/logout" element={<Logout />} />));
export function PR() {
  return <RP router={r} />;
}
